import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelfEmployedModel } from './selfemployed.model';
import { SelfEmployedService } from './selfemployed.service';
import { ActualSelected } from '../../../shared/utils';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Component({
    selector: 'convfact-selfemployed',
    templateUrl: './selfemployed.component.html',
    styleUrls: ['./selfemployed.component.css'],
    standalone: false
})

export class SelfEmployedComponent implements OnInit {
    selfEmployed = new SelfEmployedModel;
    errors = {};

    submit(): void { }

    constructor(
        private selfEmployedService: SelfEmployedService,
        private route: ActivatedRoute,
        private router: Router,
        public snackBar: MatSnackBar
    ) { }

    saveData = function (selfEmployed: SelfEmployedModel) {
        selfEmployed.fiscalYear = parseInt(ActualSelected.yearSelected);
        if (selfEmployed.uid == null) {
            this.selfEmployedService.addData(selfEmployed)
                .then(selfEmployed => {
                    this.selfEmployed = selfEmployed;
                    this.returnToIndex();
                }).catch(errors => {
                    if (errors && errors.error && errors.error.message) {
                        this.displayInfo(errors.error.message);
                    } else {
                        this.displayInfo('Compruebe los campos obligatorios marcados en rojo');
                    }
                });
        } else {
            this.selfEmployedService.editData(selfEmployed.uid, selfEmployed)
                .then(selfEmployed => {
                    this.selfEmployed = selfEmployed;
                    this.returnToIndex();
                }).catch(errors => {
                    if (errors && errors.error && errors.error.message) {
                        this.displayInfo(errors.error.message);
                    } else {
                        this.displayInfo('Compruebe los campos obligatorios marcados en rojo');
                    }
                });
        }
    }

    displayInfo(response: string): void {
        const options = new MatSnackBarConfig();
        const self = this;
        options.duration = 10500;
        this.snackBar.open(response, '', options);
    }

    ngOnInit() {
        const temp = this.route.params['_value'];
        const uid = temp['selfEmployedUid'];
        if (uid != null) {
            this.selfEmployedService.loadData(uid).then(selfEmployed => {
                this.selfEmployed = selfEmployed;
            }
            );
        }
    }

    returnToIndex = function () {
        this.router.navigate(['/expense/selfemployed']);
    }

}